var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup22(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.825,
    height: 54.332,
    viewBox: "0 0 55.825 54.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(-1763.949 -1011.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1929.631,1055.231h-1.255v-19.363a5.931,5.931,0,0,0-11.844-.491h-2.538a1.44,1.44,0,1,0,0,2.881h5.96a1.44,1.44,0,0,0,0-2.881h-2.44a4.952,4.952,0,0,1,9.88.491v19.363h-16.86a.491.491,0,0,0,0,.982h19.1a.941.941,0,0,1,0,1.881h-19.1a.491.491,0,0,0,0,.982h18.084v.55a16.983,16.983,0,0,1-16.963,16.965h-.932a.491.491,0,0,0,0,.982h.932a17.966,17.966,0,0,0,17.945-17.947v-.55h.031a1.922,1.922,0,0,0,0-3.845Zm-9.218-18.414a.458.458,0,0,1-.458.458h-5.96a.458.458,0,1,1,0-.917h5.96A.458.458,0,0,1,1920.413,1036.817Z",
    transform: "translate(-112.194 -14.331)",
    fill: "#073448",
    stroke: "#073448",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1928.251,1069.563v-1.653a.491.491,0,1,0-.982,0v1.653a.491.491,0,0,0,.982,0Z",
    transform: "translate(-125.445 -43.178)",
    fill: "#073448",
    stroke: "#073448",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1935.375,1073.141v-1.652a.491.491,0,1,0-.982,0v1.652a.491.491,0,0,0,.982,0Z",
    transform: "translate(-130.925 -45.93)",
    fill: "#073448",
    stroke: "#073448",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1942.5,1069.563v-1.653a.491.491,0,1,0-.982,0v1.653a.491.491,0,0,0,.982,0Z",
    transform: "translate(-136.405 -43.178)",
    fill: "#073448",
    stroke: "#073448",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1949.616,1073.141v-1.652a.491.491,0,1,0-.982,0v1.652a.491.491,0,0,0,.982,0Z",
    transform: "translate(-141.88 -45.93)",
    fill: "#073448",
    stroke: "#073448",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1784.715,1057.5a.491.491,0,0,0-.491.491.994.994,0,0,1-1.988,0,.491.491,0,0,0-.982,0,1.976,1.976,0,0,0,3.952,0A.491.491,0,0,0,1784.715,1057.5Z",
    transform: "translate(-13.121 -35.545)",
    fill: "#073448",
    stroke: "#073448",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1829.309,1057.5a.491.491,0,0,0-.491.491,1,1,0,0,1-.994.994.983.983,0,0,1-.994-.994.491.491,0,0,0-.982,0,1.976,1.976,0,0,0,3.952,0A.491.491,0,0,0,1829.309,1057.5Z",
    transform: "translate(-47.425 -35.545)",
    fill: "#073448",
    stroke: "#073448",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1871.423,1057.988a.491.491,0,0,0-.982,0,1.968,1.968,0,1,0,3.937,0,.491.491,0,0,0-.982,0,.987.987,0,1,1-1.973,0Z",
    transform: "translate(-81.729 -35.545)",
    fill: "#073448",
    stroke: "#073448",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1819.033,1011.291H1764.7a.491.491,0,0,0,0,.982h4.924v5.051a3.585,3.585,0,0,1-2.025-.821,4.434,4.434,0,0,0-2.9-1.035.491.491,0,0,0-.491.491v46.791a.491.491,0,0,0,.491.491,3.47,3.47,0,0,1,2.331.849,4.58,4.58,0,0,0,5.793,0,3.545,3.545,0,0,1,2.428-.85,3.486,3.486,0,0,1,2.23.849,4.608,4.608,0,0,0,5.816,0,3.625,3.625,0,0,1,4.663,0,4.6,4.6,0,0,0,5.809,0,3.475,3.475,0,0,1,2.332-.849.49.49,0,0,0,.491-.491v-46.791a.491.491,0,0,0-.491-.491,4.438,4.438,0,0,0-2.9,1.035,3.59,3.59,0,0,1-2.013.82v-5.05h27.859a.491.491,0,1,0,0-.982Zm-39.127.982v5.035a3.652,3.652,0,0,1-1.854-.806,4.594,4.594,0,0,0-5.815,0,3.769,3.769,0,0,1-1.636.781v-5.015Zm13.854,5.025a3.584,3.584,0,0,1,1.841-.823v45.805a4.5,4.5,0,0,0-2.414,1.011,3.626,3.626,0,0,1-4.663,0,4.6,4.6,0,0,0-5.81,0,3.635,3.635,0,0,1-4.669,0,4.554,4.554,0,0,0-2.9-1.033,4.437,4.437,0,0,0-2.907,1.036,3.607,3.607,0,0,1-4.646,0,4.494,4.494,0,0,0-2.414-1.011v-45.805a3.574,3.574,0,0,1,1.84.823,4.545,4.545,0,0,0,2.6,1.005v3.4a.491.491,0,1,0,.982,0v-3.434a4.658,4.658,0,0,0,2.211-.969,3.626,3.626,0,0,1,4.667,0,4.609,4.609,0,0,0,2.427.988v3.418a.491.491,0,1,0,.982,0v-3.42a4.636,4.636,0,0,0,2.4-.986,3.626,3.626,0,0,1,4.666,0,4.672,4.672,0,0,0,2.244.971v3.433a.491.491,0,1,0,.982,0v-3.4A4.546,4.546,0,0,0,1793.76,1017.3Zm-3.567-.009a3.749,3.749,0,0,1-1.67-.786,4.6,4.6,0,0,0-5.812,0,3.671,3.671,0,0,1-1.823.8v-5.031h9.305Z",
    fill: "#073448",
    stroke: "#073448",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M1810.478,1114.334a.491.491,0,0,0-.491.491v14.852a.491.491,0,1,0,.982,0v-14.852A.491.491,0,0,0,1810.478,1114.334Z",
    transform: "translate(-35.223 -79.268)",
    fill: "#073448",
    stroke: "#073448",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1856.6,1114.334a.491.491,0,0,0-.491.491v14.852a.491.491,0,0,0,.982,0v-14.852A.491.491,0,0,0,1856.6,1114.334Z",
    transform: "translate(-70.702 -79.268)",
    fill: "#073448",
    stroke: "#073448",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22);
export default __webpack_public_path__ + "static/media/Group 22.5601044fb789825e900985d348d21dc7.svg";
export { ForwardRef as ReactComponent };